<template>
  <div style="min-height: 50px; width: 100%;">

    <b-input-group v-if="filterOptions.length === 0">
      <b-form-input v-model="filterValue" type="text" :disabled="isDisabled" :placeholder="placeholder" class="mr-0" @input="onSelectChange(true)"></b-form-input>
      <b-input-group-append>
        <b-button variant="outline-secondary" class="m-0" @click="() => { initClassificationPlan(); }">{{ $t('text.globals.getClassificationPlan') }}</b-button>
      </b-input-group-append>
    </b-input-group>

    <div>
      <loading :active.sync="isLoading"
               :can-cancel="false"
               :is-full-page="false"></loading>

      <v-select :options="filterOptions" v-if="filterOptions.length > 0"
                :reduce="item => item.classificationLabel"
                :id="id"
                :label="'classificationLabelName'"
                :placeholder="placeholder"
                :filter-by="knSearchFilter"
                class="form-control"
                @input="onSelectChange(true)"
                v-model="filterValue"
                :disabled="isDisabled">
        <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
        <template v-slot:option="option">
          {{ option.classificationLabelName }} <small class="pl-2 text-muted">({{ option.classificationLabel }})</small>
        </template>
        <template v-slot:selected-option="option">
          {{ option.classificationLabelName }} <small class="pl-2 text-muted">({{ option.classificationLabel }})</small>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios/index';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import convert from "xml-js";
import flatten from "flat";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'ClassificationClassDropdown',
  props: ['id', 'isDisabled', 'placeholder', 'value'],
  components: {
    vSelect,
    Loading
  },
  data() {
    return {
      isLoading: false,
      filterValue: this.value,
      vpisniki: [],
      povezaniSistemi: [],
      filterOptions: [],
      rokHrambe: [],
      vrstaGradiva: [],
      classificationPlan: [],
      classificationPlanDropdownOptions: [],
      knSearchFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.classificationLabel.toLowerCase().indexOf(temp) > -1 ||
            option.classificationLabelName.toLowerCase().indexOf(temp) > -1
      }
    }
  },
  watch: {
    value: function (val) {
      if (val !== this.filterValue) {
        this.filterValue = val;
      }
    }
  },
  async mounted() {
    const _this = this;




  },
  methods: {
    async initClassificationPlan() {
      const _this = this;

      if (this.filterOptions.length === 0) {
        _this.isLoading = true;
        await this.getClassificationPlan();
        _this.filterOptions = this.classificationPlanDropdownOptions;
        console.log("_this.filterOptions", _this.filterOptions);
        _this.isLoading = false;
      }
    },
    onSelectChange() {
      this.$forceUpdate();
      this.$emit('knSelected', this.filterValue);
    },
    async getClassificationPlan(params) {
      const _this = this;

      _this.isLoadingCP = true;

      await axios
          .get(config.alfrescoServiceApi + "rma/admin/ehramba/fileplan")
          .then(async res => {
            //console.log(res);


            await _this.$store.dispatch('clearClassificationPlanDeletedClass');

            let options = {
              compact: true
            };

            this.locallyDeletedClasses = false;

            let classificationPlanJs = convert.xml2js(res.data, options);

            await this.$store.dispatch(
                "setClassificationPlanSessionHash",
                classificationPlanJs.root.meta.hash._text
            );

            this.classificationPlan = this.formatObject(
                classificationPlanJs,
                "fromServer"
            );

            for (let i = 0; i < _this.classificationPlan.length; i++) {
              _this.classificationPlan[i].structure.isOpen = false;
            }

            await this.$store.dispatch(
                "setClassificationPlan",
                this.classificationPlan
            );
            this.classificationPlan = this.$store.getters.getClassificationPlan;

            this.isLoadingCP = false;
            this.formatClassificationPlan();


          })
          .catch(error => {
            console.error(error);

            _this.showConnectToAlfrescoErrorWarning = true;

            this.isLoadingCP = false;
          });
    },

    formatClassificationPlan() {

      if (!this.classificationPlan) {
        return null
      }

      let classificationPlan = _.cloneDeep(
          this.classificationPlan
      );

      let flattenClassificationPlan = flatten(classificationPlan);
      let classificationPlanToReturn = [];

      // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
      _.map(flattenClassificationPlan, function (val, key, idx) {
        if (key.indexOf('classificationLabelName') > -1) {
          let index = 0;
          let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

          if ((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
            let item = {
              classificationLabelName: val,
              classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
            }
            classificationPlanToReturn.push(item);
          }
        }
      });

      console.log("classificationPlanToReturn", classificationPlanToReturn);
      this.classificationPlanDropdownOptions = classificationPlanToReturn;

    },

    // formatira pretvorjen Klasifikacijski načrt v ustrezno strukturo, ki nam bo olajšala delo z njo
    // we adjust the classification plan structure, so it is easier to work with later
    formatObject(classificationPlanJs, typeOfImport) {
      let classificationPlanFormatted = [];

      // če je root element objekt, ga spremenimo v array
      // if the root class (root.item) is an object, we convert it to an array

      if (!classificationPlanJs.root.item) {
        return classificationPlanFormatted;
      }

      if (classificationPlanJs.root.item.length == null) {
        let itemRootArray = [];
        itemRootArray.push(classificationPlanJs.root.item);
        classificationPlanJs.root.item = itemRootArray;
      }

      if (classificationPlanJs.root.item.length > 0) {
        classificationPlanJs.root.item = _.sortBy(
            classificationPlanJs.root.item,
            [
              function (o) {
                return o.classificationLabel._text;
              }
            ]
        );
      }

      for (let i = 0; i < classificationPlanJs.root.item.length; i++) {
        let obj = this.formatObjectRec(
            classificationPlanJs.root.item[i],
            1,
            "none",
            typeOfImport
        );

        _.map(obj, function (v, k) {
          if (k == "item") {
            obj[k] = _.sortBy(v, [
              function (o) {
                return o.classificationLabel;
              }
            ]);
          }
        });
        classificationPlanFormatted.push(obj);
      }

      return classificationPlanFormatted;
    },

    formatObjectRec(
        classificationPlanJsItem,
        depth,
        parentClassLabel,
        typeOfImport
    ) {
      let formattedClass = {
        alfrescoId: null,
        classificationLabel: null,
        containsRecords: false,
        classificationLabelName: null,
        classificationLabelDescription: null,
        duplicatedClassLabels: [],
        rokHrambe: [],
        vpisnik: [],
        povezaniSistemi: [],
        usageEndDate: null,
        usageStartDate: null,
        creationDate: null,
        parentClass: null,
        item: [],
        errors: {
          classificationLabelNameDuplicateError: false,
          classificationLabel: {
            missing: null,
            valueError: null
          },
          classificationLabelName: null,
          classificationLabelDescription: null,
          rokHrambe: {
            expirationErrors: null,

            generalExpirationError: null,
            expirationFields: []
          },
          povezaniSistemi: null,
          vpisnik: null
        },
        structure: {
          isOpen: null,
          checked: null,
          depth: null,
          changed: false,
          match: false
        }
      };

      if (typeOfImport === "fromServer") {
        formattedClass.structure.changed = false;
      } else if (typeOfImport === "fromXml") {
        formattedClass.structure.changed = true;
      }

      if (
          classificationPlanJsItem.classificationLabel &&
          classificationPlanJsItem.classificationLabel._text
      ) {
        formattedClass.classificationLabel =
            classificationPlanJsItem.classificationLabel._text;
      }

      if (
          classificationPlanJsItem.classificationLabelName &&
          classificationPlanJsItem.classificationLabelName._text
      ) {
        formattedClass.classificationLabelName =
            classificationPlanJsItem.classificationLabelName._text;
      }

      if (
          classificationPlanJsItem.classificationLabelDescription &&
          classificationPlanJsItem.classificationLabelDescription._text
      ) {
        formattedClass.classificationLabelDescription =
            classificationPlanJsItem.classificationLabelDescription._text;
      }

      if (
          classificationPlanJsItem.alfrescoId &&
          classificationPlanJsItem.alfrescoId._text
      ) {
        formattedClass.alfrescoId = classificationPlanJsItem.alfrescoId._text;
      }

      if (
          classificationPlanJsItem.containsRecords &&
          classificationPlanJsItem.containsRecords._text
      ) {
        formattedClass.containsRecords =
            classificationPlanJsItem.containsRecords._text === "true";
      }

      // for expiration we need to also go through all of the fields in a expiration entry
      if (classificationPlanJsItem.rokHrambe) {
        if (classificationPlanJsItem.rokHrambe.length == null) {
          let rokHrambeArray = [];
          rokHrambeArray.push(classificationPlanJsItem.rokHrambe);

          classificationPlanJsItem.rokHrambe = rokHrambeArray;
        }

        let rokHrambeDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.rokHrambe.length; i++) {
          let expirationEntry = {
            expiration: null,
            year: null,
            expirationType: null,
            isGeneral: false,
            alfrescoId: null
          };

          if (
              classificationPlanJsItem.rokHrambe[i].alfrescoId &&
              classificationPlanJsItem.rokHrambe[i].alfrescoId._text
          ) {
            expirationEntry.alfrescoId =
                classificationPlanJsItem.rokHrambe[i].alfrescoId._text;
          }

          if (
              classificationPlanJsItem.rokHrambe[i].expiration &&
              classificationPlanJsItem.rokHrambe[i].expiration._text
          ) {
            let expirationOptions = this.rokHrambe;

            let expirationErrors = true;

            for (let j = 0; j < expirationOptions.length; j++) {
              if (
                  classificationPlanJsItem.rokHrambe[
                      i
                      ].expiration._text.toString() ===
                  expirationOptions[j].type.toString()
              ) {
                expirationErrors = false;
                break;
              }
            }

            if (!expirationErrors) {
              expirationEntry.expiration =
                  classificationPlanJsItem.rokHrambe[i].expiration._text;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].expirationType &&
              classificationPlanJsItem.rokHrambe[i].expirationType._text
          ) {
            // let expirationTypeOptions = ['ZUP povratnica PUND','ZUP povratnica Su','ZPP povatnica PUND',
            //     'ZPP povratnica iI', 'Tožba', 'Vloga', 'Pritožba', 'Sodba'];
            //let expirationTypeOptions = this.$store.getters.getStorageDateOptions;

            let expirationTypeOptions = this.vrstaGradiva;

            let expirationTypeErrors = true;

            for (let j = 0; j < expirationTypeOptions.length; j++) {
              if (
                  classificationPlanJsItem.rokHrambe[i].expirationType._text ==
                  expirationTypeOptions[j].id.toString()
              ) {
                expirationTypeErrors = false;
                break;
              }
            }

            if (!expirationTypeErrors) {
              expirationEntry.expirationType =
                  classificationPlanJsItem.rokHrambe[i].expirationType._text;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].isGeneral &&
              classificationPlanJsItem.rokHrambe[i].isGeneral._text
          ) {
            if (
                classificationPlanJsItem.rokHrambe[i].isGeneral._text === "true"
            ) {
              expirationEntry.isGeneral = true;
            } else if (
                classificationPlanJsItem.rokHrambe[i].isGeneral._text === "false"
            ) {
              expirationEntry.isGeneral = false;
            } else {
              expirationEntry.isGeneral = false;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].year &&
              classificationPlanJsItem.rokHrambe[i].year._text
          ) {
            expirationEntry.year =
                classificationPlanJsItem.rokHrambe[i].year._text;
          }

          if (
              !_.isEmpty(classificationPlanJsItem.rokHrambe[i]) &&
              !rokHrambeDuplicatesCheckArray.includes(
                  expirationEntry.expirationType
              )
          ) {
            rokHrambeDuplicatesCheckArray.push(expirationEntry.expirationType);
            formattedClass.rokHrambe.push(expirationEntry);
          }
        }
      }

      if (classificationPlanJsItem.povezaniSistemi) {
        if (classificationPlanJsItem.povezaniSistemi.length == null) {
          let povezaniSistemiArray = [];
          povezaniSistemiArray.push(classificationPlanJsItem.povezaniSistemi);

          classificationPlanJsItem.povezaniSistemi = povezaniSistemiArray;
        }

        let povezaniSistemiDuplicatesCheckArray = [];

        for (
            let i = 0;
            i < classificationPlanJsItem.povezaniSistemi.length;
            i++
        ) {
          let povezaniSistemiOptions = this.povezaniSistemi;

          let povezaniSistemiErrors = true;

          if (
              classificationPlanJsItem.povezaniSistemi[i]._text &&
              !povezaniSistemiDuplicatesCheckArray.includes(
                  classificationPlanJsItem.povezaniSistemi[i]._text
              )
          ) {
            povezaniSistemiDuplicatesCheckArray.push(
                classificationPlanJsItem.povezaniSistemi[i]._text
            );

            for (let j = 0; j < povezaniSistemiOptions.length; j++) {
              if (
                  classificationPlanJsItem.povezaniSistemi[i]._text ===
                  povezaniSistemiOptions[j].id.toString()
              ) {
                povezaniSistemiErrors = false;
                break;
              }
            }

            if (!povezaniSistemiErrors) {
              formattedClass.povezaniSistemi.push(
                  classificationPlanJsItem.povezaniSistemi[i]._text
              );
            }
          }
        }
      }

      if (classificationPlanJsItem.vpisnik) {
        if (classificationPlanJsItem.vpisnik.length == null) {
          let vpisnikArray = [];
          vpisnikArray.push(classificationPlanJsItem.vpisnik);

          classificationPlanJsItem.vpisnik = vpisnikArray;
        }

        let vpisnikDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.vpisnik.length; i++) {
          this.getVpisnikiOptions(formattedClass);
          let vpisnikOptions = this.filteredVpisniki;

          let vpisnikErrors = true;

          if (
              classificationPlanJsItem.vpisnik[i]._text &&
              !vpisnikDuplicatesCheckArray.includes(
                  classificationPlanJsItem.vpisnik[i]._text
              )
          ) {
            vpisnikDuplicatesCheckArray.push(
                classificationPlanJsItem.vpisnik[i]._text
            );

            for (let j = 0; j < vpisnikOptions.length; j++) {
              if (
                  classificationPlanJsItem.vpisnik[i]._text ===
                  vpisnikOptions[j].id.toString() &&
                  _.includes(
                      formattedClass.povezaniSistemi,
                      vpisnikOptions[j].connectedSystem
                  )
              ) {
                vpisnikErrors = false;
                break;
              }
            }
            if (!vpisnikErrors) {
              formattedClass.vpisnik.push(
                  classificationPlanJsItem.vpisnik[i]._text
              );
            }
          }
        }
      }

      // we check if the imported dates are valid (if not, we remove them)

      if (
          classificationPlanJsItem.usageEndDate &&
          classificationPlanJsItem.usageEndDate._text
      ) {
        let usageEndDateMoment = this.moment(
            classificationPlanJsItem.usageEndDate._text,
            "DD-MM-YYYY"
        );

        if (usageEndDateMoment.isValid()) {
          formattedClass.usageEndDate =
              classificationPlanJsItem.usageEndDate._text;
        }
      }

      if (
          classificationPlanJsItem.usageStartDate &&
          classificationPlanJsItem.usageStartDate._text
      ) {
        let usageStartDateMoment = this.moment(
            classificationPlanJsItem.usageStartDate._text,
            "DD-MM-YYYY"
        );

        if (usageStartDateMoment.isValid()) {
          formattedClass.usageStartDate =
              classificationPlanJsItem.usageStartDate._text;
        }
      }

      // i think that we should ignore/throw out the parentClass tag, because it is easily set when importing the plan
      /*
      if(classificationPlanJsItem.parentClass && classificationPlanJsItem.parentClass._text) {
          formattedClass.parentClass = classificationPlanJsItem.parentClass._text;
      }
      */

      // we set the parent class because it is useful to have it for moving, adding new classes ...
      formattedClass.parentClass = parentClassLabel;

      //the  first two levels of the classification plan should be opened when we import the plan

      formattedClass.structure.isOpen = depth === 1 || depth === 2;
      formattedClass.structure.depth = depth;
      formattedClass.structure.checked = true;

      if (typeOfImport === "fromServer") {
        if (
            classificationPlanJsItem.creationDate &&
            classificationPlanJsItem.creationDate._text
        ) {
          formattedClass.creationDate =
              classificationPlanJsItem.creationDate._text;
        }
      } else {
        // creation date attribute is added
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        today = dd + "-" + mm + "-" + yyyy;

        formattedClass.creationDate = today;
      }

      // if there is no children we put an empty array

      if (!classificationPlanJsItem.item) {
        classificationPlanJsItem.item = [];
      }

      // if there is only one child, the parser interprets it as an object, so we need to convert it to an array
      else if (classificationPlanJsItem.item.length == null) {
        let itemArray = [];
        itemArray.push(classificationPlanJsItem.item);
        classificationPlanJsItem.item = itemArray;
      }

      //finally, we recursively call the function on all the children

      for (let i = 0; i < classificationPlanJsItem.item.length; i++) {
        formattedClass.item.push(
            this.formatObjectRec(
                classificationPlanJsItem.item[i],
                depth + 1,
                formattedClass.classificationLabel,
                typeOfImport
            )
        );
      }

      formattedClass.item = _.sortBy(
          formattedClass.item,
          [
            function (o) {
              return o.classificationLabel;
            }
          ]
      );

      return formattedClass;
    },

    getVpisnikiOptions(classificationPlan) {
      let filteredVpisniki = [];

      _.forEach(this.vpisniki, function (value, key) {
        if (
            _.includes(classificationPlan.povezaniSistemi, value.connectedSystem)
        ) {
          filteredVpisniki.push(value);
        }
      });

      this.filteredVpisniki = filteredVpisniki;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ClassificationClassDropdown.vue